<div class="ghost"></div>
<div class="header mobile-header-only">
  <div class="wrapper-home" (click)="goToZilex()">

    <div class="placeholder"></div>

  </div>
  <app-header></app-header>
  <app-language-menu></app-language-menu>
</div>
<div class="main-container">

  <div class="header desktop-header-only">
    <div class="wrapper-home" (click)="goToZilex()">
      <div class="icon-wrapper">
        <div class="placeholder"></div>
      </div>
      <div class="text">
        zilex.de
      </div>
    </div>
    <app-header></app-header>
    <app-language-menu></app-language-menu>
  </div>
  <div class="wrapper-main">
    <div class="wrapper-right">
      <div class="message" *ngIf="invalidCode">
        {{'confirmAccount.invalidCode'|translate}}</div>

      <div class="message" *ngIf="accountConfirmed">
        <div>{{'confirmAccount.accountConfirmed'|translate}} </div>
        <a class="link-item" href="/login">ZILEX</a>
      </div>
    </div>
  </div>


</div>